import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import { storeToRefs } from "pinia";
import { useThemeStore } from "@/store/modules/theme";


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "RouterLayout",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const themeStore = useThemeStore();
const { transitionName, keepAliveInclude } = storeToRefs(themeStore);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component, route }) => [
      _createVNode(_Transition, {
        name: route.meta.transition as string || _unref(transitionName),
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_KeepAlive, { include: _unref(keepAliveInclude) }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1032, ["include"]))
        ]),
        _: 2
      }, 1032, ["name"])
    ]),
    _: 1
  }))
}
}

})